export default __webpack_public_path__ + "static/media/orders-active.c0d689a3.svg";